import React, {useCallback, useContext, useEffect, useMemo, useRef, useState} from "react";
import {Card, Col, Collapse, Container, Form, Row, Modal, Button} from "react-bootstrap";
import {AgGridReact} from "ag-grid-react";
import useWindowDimensions from "hooks/Dimensions";
import template from "./template/TDPS_PORTAL_AssetTransferUpload.xlsx";
import * as URL from "service/UrlConstant";
import {ASSET_TRANSFER_BATCH_UPLOAD} from "service/UrlConstant";
import {SecurityContext} from "context/security";
import {ToastContext} from "context/Toast";
import CheckboxRenderer from "components/CheckboxRenderer";
import ResponseToast from "components/ResponseToast";
import {
    ACCOUNTS_OPTIONS_NO_SWAP,
    DEFAULT_GRID_PAGINATION_SIZE,
    ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE,
    GRID_COLUMN_PROPERTY,
    SELECTED_ENTITY
} from "utils/Constants";
import AssetTransferUploadValidationInfo from "./AssetTransferUploadValidationInfo";
import {API_CALL_ERR_MSG} from "../../utils/ConstantsMsg";
import {UtilsContext} from "../../context/utils";
import ScrollButton from "../../components/AgGridToolbar/ToolBarButtons/ScrollButton";
import {addPropertiesToGridColumns, getDisplayedNumberOfGridRows} from "../../utils/gridColumnUtils";
import {numberFormat3FractionalDigits, numberFormatter} from "../../utils/NumberUtils";
import {CustomSelect} from "../../components/CustomSelect";
import {EntityAccountsContext} from "../../components/entity-accounts/context";
import {getSessionAttribute, setSessionAttribute} from "../../utils/SessionUtils";
import {getAllErrorValuesAsString} from "../../utils/ErrorUtils";
import ExcelJS from "exceljs";
import ActionsRenderer from "../../components/ActionsRenderer";
import {ActionPanelContext} from "../../context/action";
import ActionPanelLayout from "../../layouts/ActionPanelLayout";
import {createExcelExportParams, getFilteredColumns} from "../../utils/ExcelExportUtils";
import AgGridToolbar from "../../components/AgGridToolbar/AgGridToolbar";
import DateCellEditor from "../../utils/DateCellEditor";

export default function AssetTransferUpload() {
    const {showButton, setShowButton} = useContext(UtilsContext);
    const {
        entityAccountsNoSwap, entityAccountsOptionsNoSwap, setManagerDetails, populateDefaultEntity,setInitEntityAccountsOptions
    } = useContext(EntityAccountsContext);

    const {setHandleExportFunction} = useContext(ActionPanelContext);
    const [options, setOptions] = useState([])
    const {success, alert, error} = useContext(ToastContext);
    const {makeGetRequest, makePostRequest} = useContext(SecurityContext);
    const inputFile = useRef(null);
    const [upload, setUpload] = useState(false);
    const [cancel, setCancel] = useState(false);
    const [validData, setValidData] = useState(true);
    const [errorCount, setErrorCount] = useState(0);
    const [showValidationInfo, setShowValidationInfo] = useState(false);
    const downloadFile = useRef(null);
    const [gridApi, setGridApi] = useState(null);
    const [rowData, setRowData] = useState([]);
    const {isMobile} = useWindowDimensions();
    const {resetFlagRight} = useContext(SecurityContext);
    const myGrid = useRef();
    const [subEntityOptions, setSubEntityOptions] = useState([]);
    const [selectedSubEntity, setSelectedSubEntity] = useState(subEntityOptions[0]);
    const [localEntityAccountsOptions, setLocalEntityAccountsOptions] = useState(JSON.parse(JSON.stringify(entityAccountsOptionsNoSwap)))
    const [uploadedFile, setUploadedFile] = useState(null);
    const [initialized, setInitialized] = useState(false);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [showExport, setShowExport] = useState(false);
    const [show, setShow] = useState(false);
    const [actionForAccount, setActionForAccount] = useState('');
    const [selectedOption, setSelectedOption] = useState()
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [showColumnsModal, setShowColumnsModal] = useState(false);
    const [showExportModal, setShowExportModal] = useState(false);
    const [displayedColumnCount, setDisplayedColumnCount] = useState(0);
    const [currentColumnDefs, setCurrentColumnDefs] = useState([]);
    const [showGridToolbar, setShowGridToolbar] = useState(false);
    const [columnState, setColumnState] = useState([]);
    const [paginationPageSize, setPaginationPageSize] = useState(DEFAULT_GRID_PAGINATION_SIZE);
    const hiddenExportGridApi = useRef();

    useEffect(() => {
        setHandleExportFunction({handleExport: exportQueryList, gridApi: gridApi});
        updateDisplayedColumnCount();
    }, [rowData, gridApi, currentColumnDefs]);

    useEffect(() => {
        setLocalEntityAccountsOptions(JSON.parse(JSON.stringify(entityAccountsOptionsNoSwap)))
    }, [entityAccountsOptionsNoSwap])

    useEffect(() => {
        getSessionAttribute(ACCOUNTS_OPTIONS_NO_SWAP) ?? setInitEntityAccountsOptions(true);        // set session attribute ACCOUNTS_OPTIONS to the list of all entities and their accounts fetched from the api server at login time
    }, []);

    useEffect(() => {
        const options = [];
        localEntityAccountsOptions.map(e => {
            let option = {}
            option['value'] = e.managerId
            option['label'] = e.shortName + '-' + e.longName
            options.push(option)
        })
        setOptions(options)
    }, [localEntityAccountsOptions])

    useEffect(() => {
        const selectedEntity = options.filter(e => e.value === Number(entityAccountsNoSwap.managerId));
        if (selectedEntity.length > 0) {
            setSelectedOption(selectedEntity[0]);
        } else {
            setSelectedOption();
        }
    }, [entityAccountsNoSwap.managerId, options]);

    const handleInputChangeAutoComplete = (enteredValue) => {

    }

    useEffect(() => {
        populateDefaultEntity(true, true)
    }, [])

    useEffect(() => {
        if (resetFlagRight.current) {
            window.scrollTo(0, 0);
            resetFlagRight.current = false;
            setUpload(false);
        }
    }, [resetFlagRight.current])

    useEffect(() => {
        if (selectedOption && selectedOption.value) {
            loadTemplate(selectedOption.value);
        }
    }, [selectedOption]);

    const setGridOptionSafe = (api, key, value) => {
        if (!api) return;
        if (typeof api.setGridOption === 'function') {
            api.setGridOption(key, value);
            return;
        }
        if (typeof api.updateGridOptions === 'function') {
            api.updateGridOptions({[key]: value});
        }
    };

    useEffect(() => {
        if (!gridApi) return;

        if (showCancelModal) {
            // Reduce reflow while modal is open (grid options, not GridApi methods in v26)
            setGridOptionSafe(gridApi, 'suppressRowTransform', true);
            setGridOptionSafe(gridApi, 'suppressAnimationFrame', true);
        } else {
            setGridOptionSafe(gridApi, 'suppressRowTransform', false);
            setGridOptionSafe(gridApi, 'suppressAnimationFrame', false);
        }
    }, [showCancelModal, gridApi]);


    const cellStyleChecker = (param) => {

        if (typeof param === 'string' && param.length > 0) {
            return {backgroundColor: '#ce7c7c', color: '#6e0c01'};
        }
        return {};
    }

    const validationCellStyle = params => {
        if (params.value === false) {
            return {backgroundColor: '#6e0c01', color: '#eeecec'}; // red for false
        }
        return {};
    };

    const handleExportActionClicked = (field) => {
        setShow(true);
        setShowExport(true);
    }

    const exportQueryList = (type, rowDataToExport) => {
        if (!hiddenExportGridApi.current || !hiddenExportGridApi.current.api) {
            error("Export grid not initialized. Please try again.");
            return;
        }
        const buildErrComments = (row) => {
            const errValues = Object.keys(row || {})
                .filter(key => key.startsWith('errmsg') && row[key])
                .map(key => String(row[key]).trim())
                .filter(value => value.length > 0);
            return errValues.join('; ');
        };
        let dataToExport = rowDataToExport;
        if (dataToExport) {
            const selectedRows = rowData.filter(row => row.wasselected === true);
            const rowsToExport = selectedRows.length > 0 ? selectedRows : rowData;
            dataToExport = rowsToExport.map(row => {
                const errComments = buildErrComments(row);
                if (!errComments) return row;
                const existingComments = row.comments ? String(row.comments).trim() : '';
                const combinedComments = existingComments
                    ? `${existingComments}; ${errComments}`
                    : errComments;
                return {...row, comments: combinedComments};
            });
        }

        let filteredColumnNames = [];
        if (gridColumnApi) {
            const displayedColumns = gridColumnApi.getAllDisplayedColumns();
            filteredColumnNames = displayedColumns
                .filter(col => col.colDef.field !== 'checkbox' && col.colDef.field !== 'View')
                .map(col => col.colDef.field);
        } else {
            const visibleColumnDefs = (currentColumnDefs && currentColumnDefs.length > 0 ? currentColumnDefs : updatedColumnDefs)
                .filter(cols => cols.field !== 'checkbox' && cols.field !== 'View' && !cols.hide);
            filteredColumnNames = visibleColumnDefs.map(col => col.field);
        }
        hiddenExportGridApi.current.api.setColumnDefs(updatedColumnDefs.filter(cols =>
            filteredColumnNames.includes(cols.field)
        ));

        hiddenExportGridApi.current.api.setRowData(dataToExport);

        const selectedCount = rowData.filter(row => row.wasselected === true).length;
        if (selectedCount > 0) {
            success(`Exporting ${dataToExport.length} selected row(s) with ${filteredColumnNames.length} column(s)...`);
        } else {
            success(`Exporting all ${dataToExport.length} row(s) with ${filteredColumnNames.length} column(s)...`);
        }

        // Export as csv/excel
        if (type === 'EXCEL') {
            hiddenExportGridApi.current.api.exportDataAsExcel(
                createExcelExportParams('AssetTransferUpload', filteredColumnNames)
            );
        } else {
            hiddenExportGridApi.current.api.exportDataAsCsv({columnKeys: filteredColumnNames});
        }
    }

    const updateDisplayedColumnCount = () => {
        if (gridColumnApi) {
            const displayedColumns = gridColumnApi.getAllDisplayedColumns();
            const visibleColumnCount = displayedColumns.filter(col => col.colDef.field !== 'checkbox').length;
            setDisplayedColumnCount(visibleColumnCount);
        }
    }

    const handleColumnFilterClick = (colDef) => {
        gridApi.setColumnDefs(colDef);
        setShowColumnsModal(false);
        setCurrentColumnDefs(colDef);
        updateDisplayedColumnCount();
    }

    const handleExportClick = () => {
        setShowExportModal(true);
    }


    const validateSelectedNodes = (api) => {
        let isValid = true
        let isSelectedNodeExists = false
        let errorCount = 0
        api.forEachNode((node) => {
            if (node.isSelected() === true) {
                node.data['wasselected'] = true
                isSelectedNodeExists = true
                if (node.data.validationError || node.data.commissionValidationMessage) {
                    isValid = false;
                    errorCount += 1
                    //return
                }
            } else {
                node.data['wasselected'] = false
            }
        });
        if (isSelectedNodeExists) {
            if (!isValid) {
                setErrorCount(errorCount)
                setShowValidationInfo(true);
            }
            setValidData(isValid);
        } else setValidData(false);
    }

    const nodeSelector = (api) => {
        api.forEachNode((node) => {
            if (node.data.wasselected === undefined || node.data.wasselected === true) node.setSelected(true);
        });
    }
    const onDataRendered = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
        // nodeSelector(params.api);
        if (!showCancelModal && params.columnApi) {
            params.columnApi.autoSizeAllColumns();
        }
        setShowButton(getDisplayedNumberOfGridRows(params.api) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
        setShowGridToolbar(true);  // Show toolbar when data is rendered
    }

    const defaultColDef = {
        sortable: true,
        resizable: true,
        floatingFilter: true,
        filter: true,
        enableCellChangeFlash: true,
        lockPinned: !!isMobile,
    };

    const columnTypes = {
        flexColType: {
            sortable: false,
            resizable: false,
            floatingFilter: false,
            filter: false,
            enableCellChangeFlash: false,
            suppressMenu: true,
            flex: 1,
            suppressMovable: true,
        }
    }

    const isValidTooltipValueGetter = params => {
        if (params.data && (params.data.isValid === false || params.data.canBeSaved === false)) {
            return params.data.comments || '';
        }
        return null;
    };

    const handleChangeAutocomplete = (e) => {
        setManagerDetails(e.value, e.label, true);
        let selectedEntity = {};
        selectedEntity['managerId'] = e.value;
        selectedEntity['managerName'] = e.label;
        setSessionAttribute(SELECTED_ENTITY, selectedEntity);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const getToolTipField = (data) => {
        if (data.commissionValidationMessage && data.commissionValidationMessage.length > 0) return data.commissionValidationMessage;

        return data.errmsgCommission;
    }

    const getCommCellStyle = (data) => {
        if (data.commissionValidationMessage && data.commissionValidationMessage.length > 0) return cellStyleChecker(data.commissionValidationMessage);

        return cellStyleChecker(data.errmsgCommission);
    }

    useEffect(() => {
        setSubEntityOptions([{
            value: 'default', label: 'Default Template', isDefault: true
        }]);
        setSelectedSubEntity({
            value: 'default', label: 'Default Template', isDefault: true
        });
    }, []);

    const loadTemplate = (e) => {
        const defaultOption = {
            value: 'default', label: 'Default Template', isDefault: true
        };

        if (e === 'default') {
            setSubEntityOptions([defaultOption]);
            setSelectedSubEntity(defaultOption);
            return;
        }
        const param = {
            managerId: entityAccountsNoSwap.managerId,
        }

        const onSuccessResponse = (response) => {
            const options = (response.data || []).map(template => ({
                value: template.templateName,
                label: template.templateName,
                delimiter: template.delimiter,
                headers: typeof template.headers === 'string' ? JSON.parse(template.headers) : template.headers,
                rules: typeof template.rules === 'string' ? JSON.parse(template.rules) : template.rules
            }));

            const allOptions = [defaultOption, ...options];
            setSubEntityOptions(allOptions);
            setSelectedSubEntity(allOptions[0]);
        }

        const onErrorResponse = (err) => {
            let errorMsg = getAllErrorValuesAsString(err.response.data)
            console.error("No custom asset transfer templates found for the selected entity ", errorMsg);
            error("No custom asset transfer templates found for the selected entity");
            setSubEntityOptions([defaultOption]);
            setSelectedSubEntity(defaultOption);
        }

        makeGetRequest(URL.ASSET_TRANSFER_LOAD_TEMPLATES, param, onSuccessResponse, onErrorResponse);
    };


    async function downloadAccountTemplateExcel() {
        if (selectedSubEntity && selectedSubEntity.value === 'default') {
            const link = document.createElement('a');
            link.href = template;
            const fileName = template.split('/').pop();
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return;
        }
        const headers = selectedSubEntity.headers || [];
        const rules = selectedSubEntity.rules || [];

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Template');

        const row = headers.map((header, idx) => {
            const rule = rules[idx] || '';
            const headerWithSplit = header ? header.replace(/;/g, '\n') : '';
            return rule ? `${rule}\n${headerWithSplit}` : headerWithSplit;
        });

        worksheet.addRow(row);

        row.forEach((_, idx) => {
            const cell = worksheet.getRow(1).getCell(idx + 1);
            cell.fill = {
                type: 'pattern', pattern: 'solid', fgColor: {argb: '54B848'}
            };
            cell.alignment = {wrapText: true, horizontal: 'center'};
            cell.font = {bold: true, color: {argb: '003F2D'}};

            worksheet.getColumn(idx + 1).width = 40;
        });

        row.forEach((cell, idx) => {
            const cellValue = String(cell);
            const lines = cellValue.split('\n');
            const maxLen = Math.max(...lines.map(l => l.length));
            worksheet.getColumn(idx + 1).width = Math.min(maxLen + 2, 35);

            const excelCell = worksheet.getRow(1).getCell(idx + 1);
            excelCell.fill = {
                type: 'pattern', pattern: 'solid', fgColor: {argb: '54B848'}
            };
            excelCell.alignment = {wrapText: true, horizontal: 'center'};
            excelCell.border = {
                top: {style: 'thin', color: {argb: '000000'}},
                left: {style: 'thin', color: {argb: '000000'}},
                bottom: {style: 'thin', color: {argb: '000000'}},
                right: {style: 'thin', color: {argb: '000000'}}
            };
            excelCell.font = {bold: true, color: {argb: '003F2D'}};
        });

        // Set row height
        const maxLines = Math.max(...row.map(cell => String(cell).split('\n').length));
        worksheet.getRow(1).height = 60;

        const timestamp = Date.now();

        let templateName = selectedSubEntity?.label || selectedSubEntity?.value || 'Template';
        templateName = templateName.replace(/[^a-zA-Z0-9]/g, '_');
        templateName = templateName.replace(/^_+|_+$/g, '');

        const fileName = `${templateName}_${timestamp}.xlsx`;

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const columnDefs = useMemo(() => [
        {
            headerName: '',
            headerCheckboxSelection: true,
            field: "checkbox",
            minWidth: 120,
            checkboxSelection: true,
            showDisabledCheckboxes: true,
            pinned: 'left'
        },
        {
            headerName: 'id', field: 'id', hide: true, suppressColumnsToolPanel: true
        },
        {
            headerName: 'Status',
            field: 'uiStatus',
            tooltipValueGetter: params => params.data && params.data.errmsgStatus,
            cellStyle: params => cellStyleChecker(params.data.errmsgStatus),
            pinned: 'left'
        },
        {headerName: 'status', field: 'status', hide: true, suppressColumnsToolPanel: true},
        {
            headerName: 'Request Id',
            field: 'requestId',
            tooltipValueGetter: params => params.data && params.data.errmsgRequestId,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgRequestId)
        }, {
            headerName: 'Request Type',
            field: 'requestType',
            tooltipValueGetter: params => params.data && params.data.errmsgRequestType,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgRequestType),
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['AMEND', 'CANCEL', 'NEW']
            }
        }, {
            headerName: 'Customer Reference Number',
            field: 'customerReferenceNumber',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errmsgCustomerReferenceNumber,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgCustomerReferenceNumber)
        }, {
            headerName: 'Long/Short/Cash',
            field: 'longShort',
            tooltipValueGetter: params => params.data && params.data.errmsgLongShort,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgLongShort),
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['LONG', 'SHORT', 'CASH']
            }
        }, {
            headerName: 'Instruction Type',
            field: 'instructionType',
            tooltipValueGetter: params => params.data && params.data.errmsgInstructionType,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgInstructionType),
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: ['DF', 'RF', 'RVP', 'DVP']
            }
        }, {
            headerName: 'Security Id',
            field: 'srcSecCd',
            tooltipValueGetter: params => params.data && params.data.errmsgSrcSecCd,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgSrcSecCd)
        }, {
            headerName: 'Trade Date',
            field: 'tradeDate',
            tooltipValueGetter: params => params.data && params.data.errmsgTradeDate,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgTradeDate),
            cellEditorFramework: DateCellEditor,
            valueFormatter: params => {
                if (!params.value) return '';
                if (typeof params.value === 'string') return params.value;
                try {
                    const date = new Date(params.value);
                    if (isNaN(date.getTime())) return '';
                    return date.toISOString().split('T')[0];
                } catch (e) {
                    return '';
                }
            }
        }, {
            headerName: 'Settlement Date',
            field: 'settlementDate',
            tooltipValueGetter: params => params.data && params.data.errmsgSettlementDate,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgSettlementDate),
            cellEditorFramework: DateCellEditor,
            valueFormatter: params => {
                if (!params.value) return '';
                if (typeof params.value === 'string') return params.value;
                try {
                    const date = new Date(params.value);
                    if (isNaN(date.getTime())) return '';
                    return date.toISOString().split('T')[0];
                } catch (e) {
                    return '';
                }
            }
        }, {
            headerName: 'Settlement Location',
            field: 'settlementLocation',
            tooltipValueGetter: params => params.data && params.data.errmsgSettlementLocation,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgSettlementLocation)
        }, {
            headerName: 'Settlement Currency',
            field: 'settlementCurrency',
            tooltipValueGetter: params => params.data && params.data.errmsgSettlementCurrency,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgSettlementCurrency)
        }, {
            headerName: 'Settlement Quantity',
            field: 'settlementQuantity', valueFormatter: numberFormatter,
            tooltipValueGetter: params => params.data && params.data.errmsgSettlementQuantity,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgSettlementQuantity)
        }, {
            headerName: 'Settlement Amount',
            field: 'settlementAmount', valueFormatter: numberFormat3FractionalDigits,
            tooltipValueGetter: params => params.data && params.data.errmsgSettlementAmount,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgSettlementAmount)
        }, {
            headerName: 'DTC Number',
            field: 'dtcNumber',
            tooltipValueGetter: params => params.data && params.data.errmsgDtcNumber,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgDtcNumber)
        }, {
            headerName: 'DTC Account Number',
            field: 'dtcAccountNumber',
            tooltipValueGetter: params => params.data && params.data.errmsgDtcAccountNumber,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgDtcAccountNumber)
        }, {
            headerName: 'Fed Delivery Instruction',
            field: 'fedInstruction',
            tooltipValueGetter: params => params.data && params.data.errmsgFedInstruction,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgFedInstruction)
        }, {
            headerName: 'Broker MPID ID',
            field: 'brokerMpidId',
            tooltipValueGetter: params => params.data && params.data.errmsgBrokerMpidId,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgBrokerMpidId)
        }, {
            headerName: 'CPTY account number',
            field: 'cptyAccountNumber',
            tooltipValueGetter: params => params.data && params.data.errmsgCptyAccountNumber,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgCptyAccountNumber)
        }, {
            headerName: 'Additional Information',
            field: 'additionalInformation',
            tooltipValueGetter: params => params.data && params.data.errmsgAdditionalInformation,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errmsgAdditionalInformation)
        }, {
            headerName: 'Comments',
            field: 'comments',
            tooltipValueGetter: params => params.data && params.data.errmsgComments,
            cellStyle: params =>
                params.data && params.data.status === "PENDING BROKER ACCOUNT"
                    ? {}
                    : cellStyleChecker(params.data.errmsgComments),
        }], []);

    const updatedColumnDefs = useMemo(() => addPropertiesToGridColumns(columnDefs, GRID_COLUMN_PROPERTY), []);


    const onGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
        setCurrentColumnDefs(updatedColumnDefs);
        updateDisplayedColumnCount();
    }

    const handleDownloadTemplate = () => {
        downloadFile.current.click()
    }

    const uploadComponent = function () {
        return (<Card id="uploadCard" onClick={handleUploadCardClick} className="td-bg-colour-7 p-5" align="center"
                      style={{minHeight: '350px'}}>
            <Card.Title><h1>Upload</h1></Card.Title>
            <Card.Text>
                Upload the asset transfer file.
            </Card.Text>
            <i className="td-icon-colour-primary td-icon icon-large td-icon-downloadCertificate icon-rotate"></i>
        </Card>);
    }

    const filterOptions = function () {
        return (<Row md={'12'} sm={'12'}>
            <Col md={'6'} sm={'6'}>
                <Form.Group controlId="formGridEntity"
                            id={(!!entityAccountsNoSwap.formErrors.search.entity ? 'td-select-error' : '')}>
                    <Form.Label className="filter-input-label">Entity *</Form.Label>
                    <CustomSelect
                        placeholder={'Select Entity'}
                        options={options}
                        value={selectedOption && typeof selectedOption === 'object' ? selectedOption : null}
                        onChange={handleChangeAutocomplete}
                        onInputChange={handleInputChangeAutoComplete}
                        isValid={!entityAccountsNoSwap.formErrors.search.entity}
                        className={!entityAccountsNoSwap.formErrors.search.entity ? 'is-invalid invalid' : ''}
                    />

                    {!!entityAccountsNoSwap.formErrors.search.entity && <b className={'error-text'}><i
                        className="bi bi-exclamation-circle"></i>{entityAccountsNoSwap.formErrors.search.entity}</b>}
                </Form.Group>
            </Col>
            <Col md={6} sm={6}>
                <Form.Group controlId="formGridSubEntity">
                    <Form.Label className="filter-input-label">Select Template</Form.Label>
                    <CustomSelect
                        placeholder="Select Template"
                        options={subEntityOptions}
                        value={selectedSubEntity}
                        onChange={setSelectedSubEntity}
                        isValid={true}
                    />
                </Form.Group>
            </Col>
        </Row>);
    }


    const handleUploadCardClick = () => {
        inputFile.current.click()
    }

    const handleUploadFile = (event) => {
        const file = event.target.files[0];
        setUploadedFile(file);
        const formData = new FormData();
        formData.append('file', event.target.files[0]);
        document.getElementById('file').value = null;
        setRowData([]);

        const onSuccessResponse = (response) => {
            const data = response.data || [];
            let hasError = false;
            for (const item of data) {
                for (const key in item) {
                    if (key.startsWith('errmsg') && item[key]) {
                        hasError = true;
                        break;
                    }
                }
                if (hasError) break;
            }
            if (hasError) {
                error("Some records have errors. Please review the details.");
            } else {
                success("Asset transfers Processed successfully");
            }

            setRowData(data);
            setUpload(true);
            setCancel(false);
        }


        const onErrorResponse = (err) => {
            console.error("Error on file upload", err);
            let errMsg = API_CALL_ERR_MSG;
            if (err.response && err.response.data) {
                let data = err.response.data;
                if (typeof data === 'string') {
                    try {
                        data = JSON.parse(data);
                    } catch {
                        // will keep as string if not JSON
                    }
                }
                if (typeof data === 'object' && data.message) {
                    const match = data.message.match(/ERROR:(.*)/);
                    errMsg = match ? match[1].trim() : data.message;
                } else if (typeof data === 'string') {
                    errMsg = data;
                }
            }
            error(errMsg);
            setCancel(true);
        }

        makePostRequest(formData, URL.ASSET_TRANSFER_UPLOAD_SAVE_URL, onSuccessResponse, onErrorResponse);

    }

    const onRowSelected = (params) => {
        validateSelectedNodes(params.api)
    }

    const onPaginationChange = (params) => {
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
    }

    const isRowSelectable = (params) => {
        const status = ['PENDING APPROVAL - 1', 'PENDING BROKER ACCOUNT', 'ERROR'];
        if (!params.data) return false;
        if (params.data.status && !status.includes(params.data.status)) {
            return false;
        }
        return true;
    };

    const getRowStyle = (params) => {
        if (!params.data) return {};
        if (params.data.status === "PENDING BROKER ACCOUNT") return {};
        const hasError = Object.keys(params.data).some(
            key => key.startsWith('errmsg') && params.data[key]
        );
        return hasError ? {backgroundColor: '#f5efef'} : {};
    }
    const onCellEditingStopped = useCallback((e) => {
        const status = ['PENDING APPROVAL - 1', 'PENDING BROKER ACCOUNT', 'ERROR'];
        // Only disable selection if status is NOT in allowed list and value is empty/null
        if (!(e.data.status && status.includes(e.data.status)) && (e.value === null || e.value === "")) {
            e.api.getRowNode(e.node.rowIndex).selectable = false;
            e.api.getRowNode(e.node.rowIndex).setSelected(false);
            e.api.getRowNode(e.node.rowIndex).setDataValue(e.colDef.field, "");
            return;
        }
        // Otherwise, do nothing and allow selection
    }, []);
    const handleCancelTrades = (event) => {
        setShowCancelModal(true);
    };

    const handleCloseCancelModal = (event) => {
        setShowCancelModal(false);
    };

    const handleConfirmCancelTrades = (event) => {
        setShowCancelModal(false);
        if (!gridApi) return;

        const selectedData = gridApi.getSelectedRows();

        if (selectedData.length < 1) {
            alert("No valid records are selected")
            return
        }

        const updatedRowData = selectedData.map(row => ({
            ...row,
            requestType: 'CANCEL'
        }));

        const onSuccessResponse = (response) => {
            const data = response.data || [];
            const updatedById = new Map(data.map(row => [row.requestId, row]));
            const selectedRowsAfterUpdate = selectedData.map(row => updatedById.get(row.requestId) || row);
            const allCancelled = selectedRowsAfterUpdate.length > 0 && selectedRowsAfterUpdate.every(row => {
                const statusValue = (row.status || row.uiStatus || '').toString().toUpperCase();
                return statusValue === 'CANCELLED' || statusValue === 'CANCELED';
            });

            if (allCancelled) {
                success("All Selected Asset Transfer Cancelled successfully");
            } else {
                let hasError = false;
                for (const item of data) {
                    for (const key in item) {
                        if (key.startsWith('errmsg') && item[key]) {
                            hasError = true;
                            break;
                        }
                    }
                    if (hasError) break;
                }

                if (!hasError) {
                    success("All Selected Asset Transfer Cancelled successfully");
                } else {
                    error("Some records have errors. Please review the details.");
                }
            }

            setRowData(prevRowData => {
                const updatedMap = new Map((data).map(row => [row.requestId, row]));
                return prevRowData.map(row =>
                    updatedMap.has(row.requestId)
                        ? {...row, ...updatedMap.get(row.requestId)}
                        : row
                );
            });
            if (gridApi) {
                gridApi.deselectAll();
            }
        };

        const onErrorResponse = (err) => {
            error("Error in processing");
            if (gridApi) {
                gridApi.deselectAll();
            }
        }

        makePostRequest(updatedRowData,
            ASSET_TRANSFER_BATCH_UPLOAD, onSuccessResponse, onErrorResponse);
    }

    const handleProcessFile = (event) => {
        if (!gridApi) return;

        const selectedData = gridApi.getSelectedRows();

        if (selectedData.length < 1) {
            alert("No valid records are selected. Please review the file and reupload it")
            return
        }

        const data = [];
        selectedData.forEach(e => {
            let locateObj = {};
            columnDefs.forEach(col => {
                if (col.field) {
                    locateObj[col.field] = e[col.field];
                }
            });
            data.push(locateObj);
        });

        const onSuccessResponse = (response) => {
            const data = response.data || [];
            let hasError = false;
            for (const item of data) {
                for (const key in item) {
                    if (key.startsWith('errmsg') && item[key]) {
                        hasError = true;
                        break;
                    }
                }
                if (hasError) break;
            }
            if (hasError) {
                error("Some records have errors. Please review the details.");
            } else {
                success("Selected Asset Transfer Processed successfully");
            }

            setRowData(prevRowData => {
                const updatedMap = new Map((data).map(row => [row.requestId, row]));
                return prevRowData.map(row =>
                    updatedMap.has(row.requestId)
                        ? {...row, ...updatedMap.get(row.requestId)}
                        : row
                );
            });
            if (gridApi) {
                gridApi.deselectAll();
            }
        };

        const onErrorResponse = (err) => {
            error("Error in processing");
            if (gridApi) {
                gridApi.deselectAll();
            }
        }

        makePostRequest(data,
            ASSET_TRANSFER_BATCH_UPLOAD, onSuccessResponse, onErrorResponse);

    }

    return (<>
        <Container fluid>
            <Row className="py-4">
                <Col xs={12} className="pl-4">
                    <h1>Asset Transfer Upload</h1>
                </Col>
            </Row>
            <Collapse in={!upload} timeout={0}>
                <Row className="align-items-stretch">
                    <Col xs={12} sm={12} md={12} lg={6} className="px-4 pb-3 pt-0 h-100">
                        <Row md={'12'} sm={'12'} className="mb-4">
                        </Row>
                        <input type='file' id='file'
                               accept=".xlsx,.csv,.xls"
                               ref={inputFile} onChange={(e) => handleUploadFile(e)} style={{display: 'none'}}/>
                        {uploadComponent()}
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} className="px-4 pb-3 pt-0 h-100">
                        {filterOptions()}
                        <Card className="td-bg-colour-7 p-5" align="center" onClick={downloadAccountTemplateExcel}
                              style={{cursor: 'pointer'}}>
                            <Card.Title><h1>Download Template</h1></Card.Title>
                            <Card.Text>
                                Click to download the Account Template specific to selected entity.
                            </Card.Text>
                            <i className="td-icon-colour-primary td-icon icon-large td-icon-downloadCertificate"></i>
                        </Card>
                    </Col>
                </Row>

            </Collapse>
            <Collapse in={upload} timeout={0}>
                <Row>
                    <Col xs={12}>
                        <AgGridToolbar
                            title="Asset Transfer Upload"
                            assetTransferUploadScreen={true}
                            gridApi={gridApi}
                            gridColumnApi={gridColumnApi}
                            columnDefs={currentColumnDefs}
                            setColumnDefs={setCurrentColumnDefs}
                            onColumnFilterClick={handleColumnFilterClick}
                            showButton={showButton}
                            setShowButton={setShowButton}
                            columnState={columnState}
                            paginationPageSize={paginationPageSize}
                            setPaginationPageSize={setPaginationPageSize}
                        />
                        <div
                            id="myGrid"
                            ref={myGrid}
                            className="ag-theme-alpine ag-grid-block">
                            <AgGridReact
                                ref={myGrid}
                                frameworkComponents={{
                                    checkboxRenderer: CheckboxRenderer,
                                    actionsRenderer: ActionsRenderer,
                                    dateCellEditor: DateCellEditor
                                }}
                                paginationPageSize={DEFAULT_GRID_PAGINATION_SIZE}
                                groupDefaultExpanded={'1'}
                                enableRowGroup={false}
                                suppressRowClickSelection={true}
                                suppressDragLeaveHidesColumns={true}
                                suppressMakeColumnVisibleAfterUnGroup={true}
                                suppressModelUpdateAfterUpdateTransaction={true}
                                suppressScrollOnNewData={true}
                                suppressAggFuncInHeader={true}
                                allowShowChangeAfterFilter={false}
                                rowGroupPanelShow={'never'}
                                enableSorting={true}
                                enableFilter={true}
                                pagination={true}
                                onGridReady={onGridReady}
                                defaultColDef={defaultColDef}
                                columnTypes={columnTypes}
                                columnDefs={updatedColumnDefs}
                                getRowStyle={getRowStyle}
                                rowData={rowData}
                                animateRows={true}
                                tooltipShowDelay={0}
                                rowSelection={'multiple'}
                                onFirstDataRendered={onDataRendered}
                                onRowDataChanged={onDataRendered}
                                onRowSelected={onRowSelected}
                                isRowSelectable={isRowSelectable}
                                showDisabledCheckboxes={true}
                                onCellEditingStopped={onCellEditingStopped}
                                onPaginationChanged={onPaginationChange}
                                rowHeight={28}
                            >
                            </AgGridReact>
                        </div>
                    </Col>
                </Row>
            </Collapse>
            <Collapse in={upload} timeout={0}>
                <Row className="pt-3">
                    <Col lg={6} className="d-none d-lg-block"></Col>
                    <Col sm={6} md={4} lg={2} className="pt-4 pt-sm-2 mb-xs-2">
                        <button className="btn btn-block td-btn-red" href="#"
                                onClick={handleCancelTrades}>Cancel Asset Transfers
                        </button>
                    </Col>
                    <Col sm={6} md={4} lg={2} className="pt-4 pt-sm-2 mb-xs-2">
                        <button className="btn btn-block td-btn-primary-light" href="#"
                                onClick={handleProcessFile}>Process Asset Transfers
                        </button>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={2} className="pt-2">
                        <button className="btn btn-block td-btn-secondary-clear" href="#" onClick={() => {
                            setUpload(false);
                        }}>Upload Another File
                        </button>
                    </Col>
                </Row>
            </Collapse>
            <Collapse in={show} timeout={0}>
                <Row>
                    <Col xs={12}>
                        <div className="p-4 td-bg-colour-7">
                            <h2>Asset Transfer Process</h2>
                            <p>Review and confirm the asset transfer details before processing.</p>
                        </div>
                    </Col>
                </Row>
            </Collapse>
            <AssetTransferUploadValidationInfo show={showValidationInfo} errorCount={errorCount}
                                               onHide={() => setShowValidationInfo(false)}></AssetTransferUploadValidationInfo>
        </Container>
        {showButton && <ScrollButton showButton={showButton}/>}
        <ActionPanelLayout actionForAccount={actionForAccount} show={show} setShow={setShow}
                           showExport={showExport} setShowExport={setShowExport}
                           gridApi={gridApi}
        />
        <ResponseToast isFullWidth={true}/>
        <Modal
            show={showCancelModal}
            onHide={handleCloseCancelModal}
            centered
            container={document.body}
            backdrop="static"
            keyboard={false}
            autoFocus={false}
            enforceFocus={false}
            restoreFocus={false}
            animation={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Confirm Cancellation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to cancel the selected asset transfers?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseCancelModal}>
                    Close
                </Button>
                <Button className="btn td-btn-red" onClick={handleConfirmCancelTrades}>
                    Confirm Cancel
                </Button>
            </Modal.Footer>
        </Modal>
        <div style={{display: 'none'}}>
            <div id="hiddenExportGrid" className="ag-theme-alpine" style={{width: '100%', height: '100%'}}>
                <AgGridReact ref={hiddenExportGridApi}/>
            </div>
        </div>
    </>);
}

